/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import redirect from 'js/lib/coursera.redirect';
import useRouter from 'js/lib/useRouter';

import { Button, Grid, PageGridContainer, Typography } from '@coursera/cds-core';
import { ArrowPreviousIcon } from '@coursera/cds-icons';

import AlertSvg from 'bundles/enterprise-admin-roles/components/AlertSvg';

import _t from 'i18n!nls/enterprise-ui';

const styles = {
  wrapper: () => css`
    margin-top: var(--cds-spacing-300);
  `,
  body: () => css`
    margin-top: var(--cds-spacing-600);
  `,
  header: () => css`
    margin-top: var(--cds-spacing-300);
    margin-bottom: var(--cds-spacing-200);
  `,
  primaryButton: () => css`
    margin-top: var(--cds-spacing-200);
  `,
};

export const AccessDenied = () => {
  const router = useRouter();
  const { params } = router;
  const onReturn = () => {
    redirect.setLocation(`/o/${params.thirdPartySlug}/admin/home`);
  };
  return (
    <PageGridContainer maxWidth="lg">
      <Grid container direction="column" css={styles.wrapper}>
        <Grid>
          <Button
            variant="ghost"
            size="small"
            iconPosition="before"
            icon={<ArrowPreviousIcon />}
            onClick={onReturn}
            edgeAlign="start"
            data-testid="top-return-to-org-home-button"
          >
            {_t('Return to organization home')}
          </Button>
        </Grid>
        <Grid container direction="column" alignItems="center" justifyContent="center" css={styles.body}>
          <AlertSvg />
          <Typography variant="d2" css={styles.header} align="center">
            {_t(`You need access to view this page`)}
          </Typography>
          <Typography variant="h2" component="p" align="center">
            {_t('Please reach out to your organization admin to request access to this page.')}
          </Typography>
          <Button
            variant="primary"
            iconPosition="before"
            icon={<ArrowPreviousIcon />}
            onClick={onReturn}
            css={styles.primaryButton}
            data-testid="bottom-return-to-org-home-button"
          >
            {_t('Return to organization home')}
          </Button>
        </Grid>
      </Grid>
    </PageGridContainer>
  );
};
